import React, { useState } from "react";
import { toast } from "react-toastify";
import { Create_Api } from "../ApiUrls";
import { FaWhatsapp, FaCalculator, FaPhone } from "react-icons/fa";

function FloatingForm() {
    const [IsUploading, setIsUploading] = useState(false);
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [Email, setEmail] = useState("");
    const [Number, setNumber] = useState("");
    const [Message, setMessage] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    const openclose = () => {
        setIsOpen(!isOpen);
    };

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isValidPhoneNumber = (number) => /^[6-9]\d{9}$/.test(number);
    const isValidName = (name) => /^[A-Za-z]{2,}$/.test(name);

    const SendContactUs = async () => {
        if (!FirstName.trim() || !isValidName(FirstName)) return toast.error("First Name must contain at least 2 letters and no numbers!");
        if (!LastName.trim() || !isValidName(LastName)) return toast.error("Last Name must contain at least 2 letters and no numbers!");
        if (!Email.trim() || !isValidEmail(Email)) return toast.error("Enter a valid email address!");
        if (!Number.trim() || !isValidPhoneNumber(Number)) return toast.error("Enter a valid 10-digit mobile number!");
        if (!Message.trim() || Message.length < 10) return toast.error("Message should be at least 10 characters long!");

        try {
            let data = { FirstName, LastName, Email, Number, Message };
            setIsUploading(true);
            const response = await Create_Api("api/admin/CreateContactUs", data);
            toast.success(response?.message);
            setFirstName("");
            setLastName("");
            setEmail("");
            setNumber("");
            setMessage("");
            setIsUploading(false);
            setIsOpen(false);
        } catch (error) {
            setIsUploading(false);
            toast.error(error?.response?.data?.message);
            console.log(error);
        }
    };

    return (
        <>
            <div className="fixed-buttons">
                <button onClick={openclose} className="fixed-btn call">
                    <FaPhone size={24} />
                </button>
            </div>

            {/* Contact Modal */}
            {isOpen && (
                <div className="floating-contact-modal">
                    <div className="floating-contact-content">
                        <div className="floating-contact-header">
                            <h2>Contact Info</h2>
                            <button className="floating-close-button" onClick={() => setIsOpen(false)}>
                                &times;
                            </button>
                        </div>
                        <div className="floating-contact-form">
                            <div className="floating-input-field">
                                <label>First Name</label>
                                <input
                                    type="text"
                                    placeholder="Enter First Name"
                                    value={FirstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>
                            <div className="floating-input-field">
                                <label>Last Name</label>
                                <input
                                    type="text"
                                    placeholder="Enter Last Name"
                                    value={LastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                            <div className="floating-input-field">
                                <label>Email</label>
                                <input
                                    type="email"
                                    placeholder="Enter Email"
                                    value={Email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div className="floating-input-field">
                                <label>Number</label>
                                <input
                                    type="tel"
                                    placeholder="Enter Number"
                                    value={Number}
                                    onChange={(e) => setNumber(e.target.value)}
                                />
                            </div>
                            <div className="floating-input-field">
                                <label>Message</label>
                                <textarea
                                    placeholder="Enter Message"
                                    value={Message}
                                    onChange={(e) => setMessage(e.target.value)}
                                ></textarea>
                            </div>
                            <button className="floating-submit-button" onClick={SendContactUs} disabled={IsUploading}>
                                {IsUploading ? "Please Wait..." : "Send"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default FloatingForm;
